module.exports = __webpack_public_path__ + "static/media/erikbaan.6799f38f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/erikbaan.webp
// module id = 888
// module chunks = 0